/**
 * The initial value of Symbol.matchAll is the well-known symbol @@matchAll
 * https://tc39.es/ecma262/#sec-symbol.matchall
 */
export const symbolMatchAll = () => Symbol("Symbol.matchAll");
